module.exports = __webpack_public_path__ + "img/ktg_aimak.1a7f68f3.svg";